import { render, staticRenderFns } from "./WorkflowSalden.vue?vue&type=template&id=66d8641e"
import script from "./WorkflowSalden.vue?vue&type=script&lang=ts"
export * from "./WorkflowSalden.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports